var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { SdsLabelBase } from '../_sds-label-base.lit';
import styles from './sds-label.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
import { property } from 'lit/decorators.js';
/**
 * `sds-label` is a web component that displays a label with optional visual elements,
 * providing context and information within user interfaces.
 * It includes various attributes to customize its appearance and behavior.
 *
 * ### Attributes
 * - `name`: The name of this label.
 * - `role`: The role associated with this label, providing context.
 * - `description`: A description for the label.
 * - `icon`: The icon associated with the label.
 * - `src`: The source URL of the label's avatar image (if applicable).
 * - `avatar-icon`: An alternative icon for the avatar (if applicable).
 * - `action`: A boolean indicating if the label has an associated action. Defaults to `false`.
 * - `selected`: A boolean indicating if the label is selected. Defaults to `false`.
 * - `focused`: A boolean indicating if the label is focused. Defaults to `false`.
 * - `selectable`: A boolean indicating if the label can be selected. Defaults to `false`.
 * - `disabled`: A boolean indicating if the label is disabled. Defaults to `false`.
 * - `identifier`: An optional identifier for the label.
 *
 * @tag sds-label
 */
let SdsLabel = (() => {
    var _SdsLabel_isInMultiselectInput_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-label')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsLabelBase;
    let _isInMultiselectInput_decorators;
    let _isInMultiselectInput_initializers = [];
    let _isInMultiselectInput_extraInitializers = [];
    var SdsLabel = _classThis = class extends _classSuper {
        get isInMultiselectInput() { return __classPrivateFieldGet(this, _SdsLabel_isInMultiselectInput_accessor_storage, "f"); }
        set isInMultiselectInput(value) { __classPrivateFieldSet(this, _SdsLabel_isInMultiselectInput_accessor_storage, value, "f"); }
        render() {
            return html ` ${this.renderLabel()} `;
        }
        renderLabel() {
            return html `
            <div
                class="${this.getClasses()}"
                @click="${(event) => this.handleClick(event)}"
                .disabled="${this.disabled}"
            >
                ${this.renderIcon()}
                <div class="sds-label__content">
                    ${this.renderName()} ${this.renderDescription()}
                </div>
                ${this.renderButtonClose()}
            </div>
        `;
        }
        renderButtonClose() {
            if (this.action) {
                return html ` <sds-button
                type="secondary"
                size="sm"
                icon="close"
                rounded=""
                .disabled="${this.disabled}"
                tabindex="${this.isInMultiselectInput ? '-1' : '0'}"
                @click="${this.handleClose}"
            ></sds-button>`;
            }
        }
        renderIcon() {
            if (this.icon) {
                return html ` <sds-icon size="24" name="${this.icon}"></sds-icon>`;
            }
        }
        renderName() {
            if (this.name) {
                return html `
                <div class="sds-label__name">
                    <sds-clipped-text text="${this.name}" basic></sds-clipped-text>
                </div>
            `;
            }
        }
        renderDescription() {
            if (this.description) {
                return html `
                <div class="sds-label__description">
                    <sds-clipped-text text="${this.description}" basic></sds-clipped-text>
                </div>
            `;
            }
        }
        constructor() {
            super(...arguments);
            _SdsLabel_isInMultiselectInput_accessor_storage.set(this, __runInitializers(this, _isInMultiselectInput_initializers, false));
            __runInitializers(this, _isInMultiselectInput_extraInitializers);
        }
    };
    _SdsLabel_isInMultiselectInput_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsLabel");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _isInMultiselectInput_decorators = [property({ type: Boolean })];
        __esDecorate(_classThis, null, _isInMultiselectInput_decorators, { kind: "accessor", name: "isInMultiselectInput", static: false, private: false, access: { has: obj => "isInMultiselectInput" in obj, get: obj => obj.isInMultiselectInput, set: (obj, value) => { obj.isInMultiselectInput = value; } }, metadata: _metadata }, _isInMultiselectInput_initializers, _isInMultiselectInput_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsLabel = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsLabel = _classThis;
})();
export { SdsLabel };
